import { render, staticRenderFns } from "./TiposProductoBase.vue?vue&type=template&id=86d8e100&"
import script from "./TiposProductoBase.vue?vue&type=script&lang=ts&"
export * from "./TiposProductoBase.vue?vue&type=script&lang=ts&"
import style0 from "./TiposProductoBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports